import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { SERVICE_ENDPOINTS } from '../../core/configs/service-endpoints';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { OrganisationData } from '../interfaces/organisation/organisation-data';

@Injectable({
  providedIn: 'root'
})
export class CustomerDataService extends BaseCrudService<OrganisationData, OrganisationData> {

  baseUrl = this.runtimeConfig.dataBackend;

  constructor() {
    super();
  }

  /**
   * get data with LazyLoading-Params (paging) for admin customer/onboarding view
   * @param lazyLoadEvent
   * @param serviceEndpoint
   * @param status
   */
  findPage(lazyLoadEvent: LazyLoadEvent, serviceEndpoint: string, status: string = null): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    if (status) {
      params = params.append('status', status);
    }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + serviceEndpoint, {headers, params});
  }

}
